export type VariantPillType = "red" | "green";

interface PillProps {
  variant: VariantPillType;
  text: string;
}

const Pill = ({ variant, text }: PillProps) => {
  let className = "w-fit px-2 py-0.5 flex place-content-center rounded-xl text-sm font-semibold";

  if (variant == "green") {
    className += " text-black bg-success200";
  } else {
    className += " text-white bg-danger200";
  }

  return <div className={className}>{text}</div>;
};

export default Pill;
